import { inject } from 'readuz';
import { DIReader, IDictionary } from './common';

export interface ITrackPayload extends IDictionary<string | number> {
    eventId: number;
}

export type TrackAction = (payload: ITrackPayload) => void;
export const trackAction: DIReader<TrackAction> = inject(
    env => env.config,
    env => env.logError,
    ({ TRACK_ACTION_URL }, logError) => (payload) => {
        fetch(TRACK_ACTION_URL, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        }).catch(e => {
            logError('Cannot send track request: ', e);
        });
    },
);
